import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./hero.css";
import LazyBackground from "../../Lazy/lazy-background";

const Hero = () => {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15,
      },
    },
  };

  const buttonVariants = {
    hover: {
      scale: 1.05,
      transition: { duration: 0.2 },
    },
    tap: {
      scale: 0.95,
      transition: { duration: 0.1 },
    },
  };

  return (
    <section className="hero-section">
        <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/background5.svg`}
            alt=""
            className="home-background home-background2"
            loading="lazy"
          />
        <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/left-lights.svg`}
            alt=""
            className="home-background left-lights"
            loading="lazy"
          />
        <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/right-lights.svg`}
            alt=""
            className="home-background right-lights"
            loading="lazy"
          />
      <div className="hero-content">
        <motion.div
          className="hero-text-container"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1 variants={itemVariants}>
            Transform your health with genetic insights: order genetic tests
            with ease
          </motion.h1>
          <motion.p variants={itemVariants}>
            Whether you’re assessing your genetic risk for cancer, checking the
            genetics of your unborn baby, determining which medicines work best
            for you, and more, you can order it all{" "}
          </motion.p>
          <span>Conveniently here on direct!</span>
          <motion.div variants={itemVariants}>
            <motion.button
              className="get-started-button"
              onClick={() => navigate("/register")}
              variants={buttonVariants}
              whileHover="hover"
              whileTap="tap"
            >
              Get started
            </motion.button>
          </motion.div>
        </motion.div>
        <motion.div
          className="hero-video-container"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.5, ease: "easeOut" }}
        >
          <video
            src={`${process.env.PUBLIC_URL}/assets/direct-video.mp4`}
            autoPlay
            loop
            muted
            playsInline
            className="hero-video"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;